import { HeroBanner } from '@ahmdigital/ui';
import { isEmpty } from 'lodash/fp';
import { useSelector } from 'react-redux';
import portableTextToPlain from '@ahmdigital/logic/lib/content/utils/portable-text-to-plain';

import { CustomExplainedTerm } from './utils/format-data-for-content-tile/types';
import { ExplainedTermSection } from './types';
import getContentToRender from './utils/get-content-to-render';
import mapTermsAndConditionsContent from '../../../utils/map-terms-and-conditions-content';
import selectCustomer from '../../../selectors/select-customer';
import TermsAndConditions from '../../insurance/components/terms-and-conditions';

type ExplainedTermDetailPageProps = {
  explainedTerm: CustomExplainedTerm;
};

const ExplainedTermDetailPage = ({ explainedTerm }: ExplainedTermDetailPageProps) => {
  const customer = useSelector(selectCustomer);
  const customerScale = customer?.scale;

  const { imageObject, slogan, summary, urlObject } = explainedTerm;
  const content = (explainedTerm.refersToContent?.filter(Boolean) ?? []) as ExplainedTermSection[];
  const explainedTermContent = content.length > 0 ? getContentToRender(content, customerScale) : null;
  const mappedTermsAndConditions = !isEmpty(explainedTerm.termsAndConditions)
    ? mapTermsAndConditionsContent({ cmsSectionContent: [explainedTerm.termsAndConditions] })
    : null;

  const heroImage = imageObject?.image?.asset?.url
    ? {
        alt: imageObject?.caption ?? undefined,
        src: imageObject.image.asset.url,
      }
    : undefined;

  const cta = urlObject?.url && urlObject.name ? { title: urlObject.name, to: urlObject.url } : undefined;

  return (
    <>
      <HeroBanner title={portableTextToPlain(slogan)} subtitle={summary} image={heroImage} cta={cta} />
      {explainedTermContent}
      {!isEmpty(mappedTermsAndConditions) && <TermsAndConditions terms={mappedTermsAndConditions?.terms} />}
    </>
  );
};

export default ExplainedTermDetailPage;
